<p-autoComplete appendTo="body" [(ngModel)]="selectedOption" [suggestions]="filteredOptions" field="label" (completeMethod)="search($event)" (onSelect)="onSelect()" (onBlur)="onBlur()"></p-autoComplete>
